module.exports = __webpack_public_path__ + "img/1478303230.f17e8477.jpg";